
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.878 18.122a3 3 0 004.244 0l3.211-3.211a1 1 0 00-1.414-1.411l-2.926 2.927L13 1a1 1 0 00-1-1 1 1 0 00-1 1l-.009 15.408-2.91-2.908a1 1 0 00-1.414 1.415z"}}),_c('path',{attrs:{"d":"M23 16a1 1 0 00-1 1v4a1 1 0 01-1 1H3a1 1 0 01-1-1v-4a1 1 0 00-1-1 1 1 0 00-1 1v4a3 3 0 003 3h18a3 3 0 003-3v-4a1 1 0 00-1-1z"}})])
          )
        }
      }
    